export const TAIPEI_TIME_ZONE = 'Asia/Taipei'

export const normalizeTs = (ts) => {
  if (typeof ts === 'string') {
    if (/Z|[+-]\d{2}:?\d{2}$/.test(ts)) return ts
    const trimmed = ts.trim()
    if (/^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(?::\d{2})?(?:\.\d+)?$/.test(trimmed)) {
      const iso0 = trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T')
      const iso = /:\d{2}:\d{2}/.test(iso0) ? iso0 : iso0.replace(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})(?!:)/, '$1:00')
      return iso + '+08:00'
    }
    return trimmed + 'Z'
  }
  return ts
}

export const formatTaipeiDate = (ts) => {
  return new Date(normalizeTs(ts)).toLocaleDateString('en-US', {
    timeZone: TAIPEI_TIME_ZONE, year: 'numeric', month: 'long', day: 'numeric'
  });
};

export const formatTaipeiDateTime = (ts) => {
  return new Date(normalizeTs(ts)).toLocaleString('en-US', {
    timeZone: TAIPEI_TIME_ZONE, year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });
};

export const formatTaipeiTime = (ts) => {
  return new Date(normalizeTs(ts)).toLocaleTimeString('en-US', {
    timeZone: TAIPEI_TIME_ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: true
  });
};

export const toTaipeiISODate = (ts) => {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: TAIPEI_TIME_ZONE, year: 'numeric', month: '2-digit', day: '2-digit'
  }).format(new Date(normalizeTs(ts)));
};

export const formatTaipeiTime24 = (ts) => {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: TAIPEI_TIME_ZONE, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false
  }).format(new Date(normalizeTs(ts)));
};
